export default "__VITE_ASSET__Lp0tEL$y__"